"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: bank/stripe/stripe-card-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fbank%2Fstripe%2Fstripe-card-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeCardServiceClient = exports.UpdatePinResponse = exports.UpdatePinRequest = exports.CreateEphemeralKeyResponse = exports.CreateEphemeralKeyRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const protobufPackage = 'com.step.stripe.proto';
function createBaseCreateEphemeralKeyRequest() {
    return { cardId: '', apiVersion: '' };
}
exports.CreateEphemeralKeyRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            apiVersion: isSet(object.apiVersion) ? globalThis.String(object.apiVersion) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.apiVersion !== '') {
            obj.apiVersion = message.apiVersion;
        }
        return obj;
    },
    create(base) {
        return exports.CreateEphemeralKeyRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateEphemeralKeyRequest();
        message.cardId = object.cardId ?? '';
        message.apiVersion = object.apiVersion ?? '';
        return message;
    },
};
function createBaseCreateEphemeralKeyResponse() {
    return { encodedKey: '', bankCardId: '' };
}
exports.CreateEphemeralKeyResponse = {
    fromJSON(object) {
        const message = {
            encodedKey: isSet(object.encodedKey) ? globalThis.String(object.encodedKey) : '',
            bankCardId: isSet(object.bankCardId) ? globalThis.String(object.bankCardId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.encodedKey !== '') {
            obj.encodedKey = message.encodedKey;
        }
        if (message.bankCardId !== '') {
            obj.bankCardId = message.bankCardId;
        }
        return obj;
    },
    create(base) {
        return exports.CreateEphemeralKeyResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateEphemeralKeyResponse();
        message.encodedKey = object.encodedKey ?? '';
        message.bankCardId = object.bankCardId ?? '';
        return message;
    },
};
function createBaseUpdatePinRequest() {
    return { cardId: '', encryptedNumber: '' };
}
exports.UpdatePinRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            encryptedNumber: isSet(object.encryptedNumber)
                ? globalThis.String(object.encryptedNumber)
                : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.encryptedNumber !== '') {
            obj.encryptedNumber = message.encryptedNumber;
        }
        return obj;
    },
    create(base) {
        return exports.UpdatePinRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdatePinRequest();
        message.cardId = object.cardId ?? '';
        message.encryptedNumber = object.encryptedNumber ?? '';
        return message;
    },
};
function createBaseUpdatePinResponse() {
    return {};
}
exports.UpdatePinResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.UpdatePinResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdatePinResponse();
        return message;
    },
};
/**
 * Stripe Card Service API.
 *
 * Provides methods to facilitate the client to manage their card directly with Stripe via SDK:
 *  - create or update PIN
 *  - retrieve card details
 *  - push provision wallet
 *
 * The non-OTP flow is as following:
 * - user enters PIN in client app
 * - client encrypts PIN and sends to Step backend
 * - Step backend verifies card ownership against user making the call
 * - Step backend makes call to Stripe to update card PIN
 *
 * Also see: https://docs.google.com/document/d/1IQ5wZ1_LkzEgyoz0173UKnDmGABzRliz_61rBH0wuxw/edit
 */
class StripeCardServiceClient {
    rpc;
    name = 'com.step.stripe.proto.StripeCardService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/stripe';
    methods = [{
            name: 'CreateEphemeralKey',
            requestType: exports.CreateEphemeralKeyRequest,
            responseType: exports.CreateEphemeralKeyResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'UpdatePin',
            requestType: exports.UpdatePinRequest,
            responseType: exports.UpdatePinResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Create ephemeral key for a given card. The key allows the client to communicate
     * directly with the issuer to update PIN, retrieve card details, or push provision a wallet.
     */
    createEphemeralKey(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Update card PIN.
     */
    updatePin(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.StripeCardServiceClient = StripeCardServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=stripe-card-service.js.map